// @flow
import type { Props } from './types';
import * as React from 'react';
import { ActionFilter, ActionTemplate, ActionTemplateDescription } from '../../';
import { DiscoveryActions, FilterStatus, FirstColumn, SecondColumn } from './styles';
import FilterTitle from './filter-title';

export default ({
    changeFilter,
    currentFilter,
    productTypesUserOwns,
    showFilter = true,
    region,
    templates,
    selectedTemplate,
    selectTemplate
}: Props) => {
    const AnchorOrDiv = showFilter ? 'a' : 'div';

    return (
        <DiscoveryActions>
            {showFilter && (
                <FirstColumn>
                    <ActionFilter
                        changeFilter={changeFilter}
                        currentFilter={currentFilter}
                        productTypesUserOwns={productTypesUserOwns}
                        region={region}
                    />
                </FirstColumn>
            )}
            <SecondColumn showFilter={showFilter}>
                {selectedTemplate ? (
                    <ActionTemplateDescription close={() => selectTemplate()} template={selectedTemplate} />
                ) : (
                    <div>
                        <FilterStatus>
                            <FilterTitle
                                currentFilter={currentFilter}
                                productTypesUserOwns={productTypesUserOwns}
                                region={region}
                            />
                        </FilterStatus>
                        {templates.map(template => (
                            <AnchorOrDiv href="#main" key={template.id} onClick={() => selectTemplate(template)}>
                                <ActionTemplate {...template} />
                            </AnchorOrDiv>
                        ))}
                    </div>
                )}
            </SecondColumn>
        </DiscoveryActions>
    );
};



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/discover-actions/component.js